// extracted by mini-css-extract-plugin
export default {"root":"Grid_root__vdsmH","grid":"Grid_grid__ou-nB"};